// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3pWVN","imageUploader":"EGiftCard_imageUploader__fTJKc"};